var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9994 22.5C6.47769 22.5 2 18.0236 2 12.5006C2.00626 6.98019 6.48019 2.50626 11.9994 2.5C17.5223 2.5 22 6.97769 22 12.5006C22 18.0236 17.5223 22.5 11.9994 22.5ZM11.9994 4.1674C7.39776 4.1674 3.66614 7.89776 3.66614 12.5006C3.67115 17.101 7.40026 20.8288 11.9994 20.8339C16.6022 20.8339 20.3339 17.1035 20.3339 12.5006C20.3339 7.89776 16.6022 4.1674 11.9994 4.1674ZM15.9404 16.4417C16.3168 16.0653 16.3168 15.455 15.9404 15.0785L13.3626 12.5007L15.9405 9.92274C16.3169 9.54632 16.3169 8.93602 15.9405 8.5596C15.5641 8.18318 14.9538 8.18318 14.5774 8.5596L11.9994 11.1376L9.42034 8.55848C9.04392 8.18205 8.43362 8.18205 8.0572 8.55847C7.68078 8.9349 7.68078 9.5452 8.0572 9.92162L10.6363 12.5007L8.05731 15.0797C7.68089 15.4561 7.68089 16.0664 8.05731 16.4428C8.43373 16.8192 9.04403 16.8192 9.42045 16.4428L11.9994 13.8638L14.5773 16.4417C14.9537 16.8181 15.564 16.8181 15.9404 16.4417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.9d6a71555c88420478397424380ca576.svg";
export { ForwardRef as ReactComponent };